import {
  AutocompleteArrayInput,
  useGetList,
} from 'react-admin';

export default function SelectEmployeeFieldEdit() {
  const { data } = useGetList('Employee', {filter: {status: 1}});

  return (
    <AutocompleteArrayInput
      optionText="fullname"
      parse={(value) => value && value.map((v) => ({ id: v }))}
      format={(value) => value && value.map((v) => v.id)}
      source="apollo_employee"
      label="Employee"
      variant="outlined"
      choices={data}
      fullWidth
    />
  );
}
